export enum PayterSessionStatus {
  New,
  Failed,
  Authorized,
  Unauthorized,
  Started,
  Stopping,
  Stopped,
  Finalizing,
  Completed,
  Cancelled,
  UnknownPayterSession,
  FailedToCommit
}
